<template>
    <div>
        <compFormEdit ref="relation" class="margin-top-15 clearfix" :formdata="getBase" v-model="formData" :labelWidth="125" col="1" />
		<div class="color-error text-center">确认复制后，目标组织、仓库对应所有Oversize规则会被清除，请谨慎操作!</div>
        <div class="text-right margin-top-10">
            <vButton theme="primary" class="margin-right-10" @click="submit()">确认复制</vButton>
            <vButton @click="cancel()">取消</vButton>
        </div>
    </div>
</template>
<script>
import { HttpCarrierCopy } from "@/service/fedex";
import { mapState, mapGetters } from "vuex";
export default {
	components: {
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
		return {
			loading:false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			detailList:[],
			formData: {
			}
		}
    },
    computed:{
		...mapGetters('dictionary', ['getWarehouseList', 'getOrgList','getCarrierServiceList']),
        getBase() {
            let showquery = this.type == 'query'
			return [
				{
                    label: "来源组织",
                    key: "sourceOrgId",
                    tag: "vSelect",
					query: showquery,
					options: this.getOrgList,
					props: {
						filterable: true,
					}
                },
                {
					label: "来源仓库",
					key: "sourceOrgWarehouseId",
					tag: "vSelect",
                    query: showquery,
					options: this.getWarehouseList,
					props: {
						filterable: true,
					}
                },
                {
                    label: "目标组织",
					key: "targetOrgId",
					tag: "vSelect",
                    query: showquery,
					options: this.getOrgList,
					props: {
						filterable: true,
					}
                },
				{
					label: "目标仓库",
					key: "targetOrgWarehouseId",
					tag: "vSelect",
					options: this.getWarehouseList,
					props: {
						filterable: true,
					}
				},
			];
        },
	},
	methods:{
		submit(){
			let bool = this.$refs.relation.validate()
			if(!bool) return
			HttpCarrierCopy({
				...this.formData
			}).then(res=>{
				this.$VMessage.success(res.message)
			},err=>{
				this.$VMessage.error(res.message)
			})
		},
		cancel(){
			this.$emit('on-close')
		}
	}
}
</script>
